export enum AttributionType {
  REGISTRATION = 'registration',
  RETURN_VISIT = 'return_visit',
  CONVERSION = 'conversion',
}

export interface CreateUserAttributionDto {
  sessionId?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmContent?: string;
  utmTerm?: string;
  utmPartner?: string;
  facebookFbp?: string;
  facebookFbc?: string;
  googleGclid?: string;
  tiktokTtclid?: string;
  tiktokTtp?: string;
  pinterestEpik?: string;
  admitadUid?: string;
  pageUrl?: string;
  referrerUrl?: string;
  placement?: string;
  siteSourceName?: string;
  attributionType?: AttributionType;
}
